import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    title: 'AI Insights',
    altAiLogo: 'AI Insights',
    altClose: 'close',
    summary: 'Summary',
    deepDive: 'Deep Dive',
    conclusion: 'Conclusion',
    overview: 'Overview',
    whatThisMeans: 'What This Means',
    whatToLookOutFor: 'What To Look Out For',
    copiedToClipboard: 'Copied to clipboard',
    researchedFor: 'Researched for {{seconds}} seconds',
    disclaimerText:
      'AI Insights is an experimental feature and can make mistakes. Always do your own research. This should not be considered investment advice.',
    errorLoadInsights: "We couldn't load that insight. Try again.",
    reloadInsights: 'Reload Insight',
    chatSendButton: 'Send',
    chatShareButton: 'Share',
    chatBuyButton: 'Buy',
    chatNewButton: 'New chat',
    chatRecents: 'Recents',
    chatEmptyState:
      'No saved conversations yet. Start chatting to see your history here.',
    chatDeleteConversation: 'Delete conversation',
    inputPlaceholder: 'Ask Altify AI',
    inputPlaceholderListening: 'Listening...',
    greeting: (name: string) => `Hey ${name}, how can I help?`,
    learnMore: 'Learn more',
    tradeCompletedFollowUp: 'Is there anything else I can help with today?',
  },
  de: {
    title: 'AI Insights',
    altAiLogo: 'AI Insights',
    altClose: 'close',
    summary: 'Summary',
    deepDive: 'Deep Dive',
    conclusion: 'Conclusion',
    overview: 'Overview',
    whatThisMeans: 'What This Means',
    whatToLookOutFor: 'What To Look Out For',
    copiedToClipboard: 'Copied to clipboard',
    researchedFor: 'Researched for {{seconds}} seconds',
    disclaimerText:
      'AI Insights is an experimental feature and can make mistakes. Always do your own research. This should not be considered investment advice.',
    errorLoadInsights: "We couldn't load that insight. Try again.",
    reloadInsights: 'Reload Insight',
    chatSendButton: 'Send',
    chatShareButton: 'Share',
    chatBuyButton: 'Buy',
    chatNewButton: 'New chat',
    chatRecents: 'Recents',
    chatEmptyState:
      'No saved conversations yet. Start chatting to see your history here.',
    chatDeleteConversation: 'Delete conversation',
    inputPlaceholder: 'Ask Altify AI',
    inputPlaceholderListening: 'Listening...',
    greeting: (name: string) => `Hey ${name}, how can I help?`,
    learnMore: 'Learn more',
    tradeCompletedFollowUp: 'Is there anything else I can help with today?',
  },
});
